// src/components/Leaderboard.js
import React, { useEffect, useState } from "react";
import { ref, onValue } from "firebase/database";
import { db } from "../services/firebase";
import "./Leaderboard.css";

const Leaderboard = ({ quizTitle = "Basic Algorithms" }) => {
  const [entries, setEntries] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const lbRef = ref(db, `leaderboard/${quizTitle}`);
    onValue(lbRef, (snapshot) => {
      const data = snapshot.val();
      if (data) {
        const list = Object.keys(data).map((userKey) => ({
          ...data[userKey],
          userKey,
        }));
        list.sort((a, b) => b.score - a.score);
        setEntries(list);
      } else {
        setEntries([]);
      }
      setLoading(false);
    });
  }, [quizTitle]);

  return (
    <div className="leaderboard-container">
      <h2>🏆 Leaderboard - {quizTitle}</h2>
      {loading ? (
        <p>Loading...</p>
      ) : entries.length === 0 ? (
        <p>No participants yet.</p>
      ) : (
        <table className="leaderboard-table">
          <thead>
            <tr>
              <th>#</th>
              <th>User</th>
              <th>Score</th>
            </tr>
          </thead>
          <tbody>
            {entries.map((entry, index) => (
              <tr key={index}>
                <td>{index + 1}</td>
                <td>{entry.user}</td>
                <td>{entry.score}</td>
              </tr>
            ))}
          </tbody>
        </table>
      )}
    </div>
  );
};

export default Leaderboard;
